import { useState, useEffect, useRef } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import SliderMain from "./SliderMain";
import PreorderService from "api/precision/PreorderService";
import Preview from "./Preview";
import CAPTCHA from "react-google-recaptcha";
import { Link } from "react-scroll";
import html2canvas from 'html2canvas';

// import BoxSleeveMail from "../see/BoxSleeveMail";
// https://reactjsexample.com/a-simple-captcha-image-generator-for-react/
// Captchs admin console - https://www.google.com/recaptcha/admin/site/680612767
// import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css';
// import 'react-phone-number-input/style.css';


const BoxSleeve = ({ templates, curTemplateName }) => {

  // Blob - Image after upload
  const [imageToCrop, setImageToCrop] = useState(undefined);
  // base64 - Image after cropped
  const [croppedImage, setCroppedImage] = useState(undefined);

  const [warning, setWarning] = useState(false);
  const [custCompleted, setCustCompleted] = useState(false);
  const [isCapturing, setIsCapturing] = useState(false);
  const [orderConfirmation, setOrderConfirmation] = useState(false);
  // Captcha ref
  const captchaRef = useRef(null);
  const messageRef = useRef(null);

  // Error array
  const errorsObj = {
    image_upload: false,
    quantity: false,
    customer_type: false,
    email: false,
    contact_name: false,
    phone: false,
    street: false,
    city: false,
    state: false,
    zip_code: false,
    candy_assortment: false,
  };
  const [errors, setErrors] = useState(errorsObj);

  // Boxsize - to pass to preview
  const [curBox, setCurBox] = useState(null);
  const [boxSizeText, setBoxSizeText] = useState('9.9 x 4.4 inches');
  const [whiteSnowflakesTempVal, setWhiteSnowflakesTempVal] = useState('whiteSnowflakes');
  const [redSnowflakesTempVal, setRedSnowflakesTempVal] = useState('redSnowflakes');
  const [houseTempVal, setHouseTempVal] = useState('house9944');
  const [confettiTempVal, setConfettiTempVal] = useState('confetti');
  const [templateFontColor, setTemplateFontColor] = useState("#000");
  const myCanvas = useRef(null);

  // Set current customizable product
  useEffect(() => {
    const template = templates[curTemplateName];
    setCurBox({
      layout: template.layout,
      product_id: "99x44",
      box_size: "9.9 x 4.4 inches",
      quantity: 50,
      Photo: null,
      contact_name: "",
      company_name: "",
      customer_type: "",
      email: "",
      phone: "",
      street: "",
      city: "",
      state: "",
      zip_code: "",
      sleeve_type: "",
      wrapping_paper: "",
      flavor: "",
      candy_assortment: "",
      design_template: curTemplateName,
      font_color: "",
      width: '800px',
      height: '355px'
    });

  }, []);

  const onUploadFile = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        // debugger;
        const widthInInches = img.naturalWidth / 300;
        const heightInInches = img.naturalHeight / 300;
        if (widthInInches < 6 || heightInInches < 3) {
          setWarning(true);
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageToCrop(e.target.result);
          setCroppedImage(e.target.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };

  const handleChange = (ev) => {
    ev.stopPropagation();

    const name = ev.target.name;
    const value = ev.target.value;
    let ok = true;

    if (name == "quantity") {
      if (value < 50) {
        setErrors({ ...errors, [name]: true });
        ok = false;
        ev.target.setAttribute("aria-invalid", "true");
      } else {
        setErrors({ ...errors, [name]: false });
        ev.target.setAttribute("aria-invalid", "false");
        setCurBox({ ...curBox, [name]: value });
      }
    }
    // Change image
    else if (name == "design_template") {
      const template = templates[value];
      setCurBox({ ...curBox, [name]: value, ["layout"]: template.layout });
    }
    else if (name === "sleeve_type") {
      setCurBox(prev => ({
        ...prev,
        sleeve_type: value
      }));
    }
    // Change boxsize
    else if (name === "candy_assortment") {
      let newWhiteSnowflakesTemplate;
      let newRedSnowflakesTemplate;
      let newHouseTemplate;
      let newConfettiTemplate;
      let newBoxSize;
      let newProductId;
      let newWidth;
      let newHeight;

      if (value.startsWith("9.9 x 4.4 inches")) {
        newWhiteSnowflakesTemplate = "whiteSnowflakes";
        newRedSnowflakesTemplate = "redSnowflakes";
        newHouseTemplate = "house9944";
        newConfettiTemplate = "confetti";
        newBoxSize = "9.9 x 4.4 inches";
        newProductId = "99x44";
        newWidth = "800px";
        newHeight = "355px";
      }
      else if (value.startsWith("9.7 X 5.7 inches")) {
        newWhiteSnowflakesTemplate = "whiteSnowflakes";
        newRedSnowflakesTemplate = "redSnowflakes";
        newHouseTemplate = "house9757";
        newConfettiTemplate = "confetti";
        newBoxSize = "9.7 X 5.7 inches";
        newProductId = "97x57";
        newWidth = "784px";
        newHeight = "461px";
      }
      else if (value.startsWith("5.5 x 3.5 inches")) {
        newWhiteSnowflakesTemplate = "whiteSnowflakes5535";
        newRedSnowflakesTemplate = "redSnowflakes5535";
        newHouseTemplate = "house5535";
        newConfettiTemplate = "confetti5535";
        newBoxSize = "5.5 x 3.5 inches";
        newProductId = "55x35";
        newWidth = "444px";
        newHeight = "283px";
      }

      setWhiteSnowflakesTempVal(newWhiteSnowflakesTemplate);
      setRedSnowflakesTempVal(newRedSnowflakesTemplate);
      setHouseTempVal(newHouseTemplate);
      setConfettiTempVal(newConfettiTemplate);
      setBoxSizeText(newBoxSize);

      setCurBox(prev => {
        let newTemplate = null;

        if (prev.design_template?.startsWith("white")) {
          newTemplate = newWhiteSnowflakesTemplate;
        } else if (prev.design_template?.startsWith("red")) {
          newTemplate = newRedSnowflakesTemplate;
        } else if (prev.design_template?.startsWith("house")) {
          newTemplate = newHouseTemplate;
        } else if (prev.design_template?.startsWith("confetti")) {
          newTemplate = newConfettiTemplate;
        }

        return {
          ...prev,
          candy_assortment: value,
          product_id: newProductId,
          box_size: newBoxSize,
          width: newWidth,
          height: newHeight,

          ...(newTemplate && {
            design_template: newTemplate,
            layout: templates[newTemplate].layout
          })
        };
      });

      setCustCompleted(true);
    }
    else if (name === "message") {
      const textarea = ev.target;

      if (textarea.scrollHeight <= textarea.clientHeight) {
        setCurBox(prev => ({
          ...prev,
          layout: {
            ...prev.layout,
            message: {
              ...prev.layout.message,
              text: value
            }
          }
        }));
      }
    } else {
      if (ev.target.required && value == "") {
        setErrors({ ...errors, [name]: true });
        ok = false;
        ev.target.setAttribute("aria-invalid", "true");
      } else {
        setErrors({ ...errors, [name]: false });
        ev.target.setAttribute("aria-invalid", "false");
        setCurBox({ ...curBox, [name]: value });
      }
    }
  };

  // Return true if customer info is valid, if tabNum = 2 include candy_assortment
  const validateForm = (skipField) => {
    let ok = true;

    for (let key in errorsObj) {
      const el = document.getElementById(key);
      if (key == "quantity") {
        if (el.value < 50) {
          errors[key] = true;
          setErrors({ ...errors, [key]: true });
          ok = ok && false;
          el.setAttribute("aria-invalid", "true");
        } else {
          errors[key] = false;
          setErrors({ ...errors, [key]: false });
          el.setAttribute("aria-invalid", "false");
        }
      } else if (skipField && key == skipField) {
      } else {
        if (!el.checkValidity()) {
          errors[key] = true;
          setErrors({ ...errors, [key]: true });
          ok = ok && false;
          el.setAttribute("aria-invalid", "true");
        } else {
          errors[key] = false;
          setErrors({ ...errors, [key]: false });
          el.setAttribute("aria-invalid", "false");
        }
      }
    }
    return ok;
  };

  const drawAdorImage = (img, ctx) => {
    const canvas = ctx.canvas;

    // Desired dimensions: half of the canvas
    const targetWidth = canvas.width / 4;
    const targetHeight = canvas.height / 4;

    // Center the image
    const translate_x = (canvas.width - targetWidth) / 4.5;
    const translate_y = (canvas.height - targetHeight) / 1.7;

    // Optional: clear the previous image
    if (lastAdorImg) {
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(
        lastAdorImg.x - 1,
        lastAdorImg.y - 1,
        lastAdorImg.w + 2,
        lastAdorImg.h + 2
      );
    }

    // Draw the new image at half the canvas size
    ctx.drawImage(
      img,
      0, 0, img.width, img.height,           // source image
      translate_x, translate_y,              // destination x, y
      targetWidth, targetHeight              // destination width, height
    );

    // Save the current image’s position and size
    setLastAdorImg({
      x: translate_x,
      y: translate_y,
      w: targetWidth,
      h: targetHeight
    });
  };

  const canvasContent = async () => {
    const element = document.getElementById("my-canvas");

    if (!element) {
      return null;
    }

    const canvas = await html2canvas(element, {
      backgroundColor: "#ffffff",
      useCORS: true,
      scale: 2,
    });

    // document.body.appendChild(canvas);  // so you can see the generated canvas on the page

    return canvas.toDataURL("image/jpeg", 0.92);
  }

  // const canvasContent = async () => {
  //   const element = document.getElementById("my-canvas");

  //   if (!element) {
  //     return null;
  //   }

  //   await document.fonts.ready;

  //   const canvas = await html2canvas(element, {
  //     backgroundColor: "#ffffff",
  //     useCORS: true,
  //     scale: 2,
  //   });

  //   return canvas.toDataURL("image/jpeg", 0.92);
  // };

  const candyOptions = [
    {
      label: "9.9 x 4.4 inches",
      options: [
        {
          value: "9.9 x 4.4 inches 1lb_Ast",
          label: "1lb Assorted Chocolates (9.9 x 4.4 inches)",
          prices: {
            standard: 37.00,
            gold: 39.00
          }
        },
        {
          value: "9.9 x 4.4 inches 2lb_Ast",
          label: "2lb Assorted Chocolates (9.9 x 4.4 inches)",
          prices: {
            standard: 68.00,
            gold: 70.00
          }
        },
        {
          value: "9.9 x 4.4 inches 1lb_Mlk",
          label: "1lb Milk Chocolates (9.9 x 4.4 inches)",
          prices: {
            standard: 37.00,
            gold: 39.00
          }
        },
        {
          value: "9.9 x 4.4 inches 1lb_Drk",
          label: "1lb Dark Chocolates (9.9 x 4.4 inches)",
          prices: {
            standard: 37.00,
            gold: 39.00
          }
        },
        {
          value: "9.9 x 4.4 inches 1lb_Soft",
          label: "1lb Soft Centers (9.9 x 4.4 inches)",
          prices: {
            standard: 37.00,
            gold: 39.00
          }
        },
        {
          value: "9.9 x 4.4 inches 1lb_C&V",
          label: "1lb Chocolate & Variety (9.9 x 4.4 inches)",
          prices: {
            standard: 37.00,
            gold: 39.00
          }
        }
      ]
    },

    {
      label: "9.7 X 5.7 inches",
      options: [
        {
          value: "9.7 X 5.7 inches 1lb_N&C",
          label: "1lb Nuts & Chews (9.7 X 5.7 inches)",
          prices: {
            standard: 37.00,
            gold: 39.00
          }
        },
        {
          value: "9.7 X 5.7 inches 2lb_N&C",
          label: "2lb Nuts & Chews (9.7 X 5.7 inches)",
          prices: {
            standard: 68.00,
            gold: 70.00
          }
        },
        {
          value: "9.7 X 5.7 inches 1_5oz_Ast_Lolly",
          label: "1.5oz Assorted Lollypops (9.7 X 5.7 inches)",
          prices: {
            standard: 37.50,
            gold: 39.50
          }
        },
        {
          value: "9.7 X 5.7 inches 1_5_PB",
          label: "1.8oz Peanut Brittle (9.7 X 5.7 inches)",
          prices: {
            standard: 37.50,
            gold: 39.50
          }
        }
      ]
    },

    {
      label: "5.5 x 3.5 Inches",
      options: [
        {
          value: "5.5 x 3.5 inches 8oz_Silver_Ast",
          label: "8oz Silver Assorted (5.5 x 3.5 inches)",
          prices: {
            standard: 22.25,
            gold: 24.25
          }
        },
        {
          value: "5.5 x 3.5 inches 8oz_Gold_Truf",
          label: "8oz Truffles (5.5 x 3.5 inches)",
          prices: {
            standard: 22.25,
            gold: 24.25
          }
        }
      ]
    }
  ];


  //#region Delete
  /*
    const [idToDelete, setIdToDelete] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => {
      setShowModal(false);
    };
    const ModalMail = (id) => {
      setShowModal(true);
    
    };
  
  // This is not working
  const convertHtmlToImage = (elementId) => {
    return new Promise((resolve, reject) => {
      const tableElement = document.getElementById(elementId); 
      html2canvas(tableElement)
        .then((canvas) => {
          resolve(canvas.toDataURL("image/jpeg"));
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  */
  //#endregion


  const handleSubmit = async (ev) => {
    ev.stopPropagation();
    ev.preventDefault();

    const messageText = document.getElementById("message")?.value || "";

    if (validateForm()) {
      const captcha_token = captchaRef.current.getValue();
      if (!captcha_token) {
        return false;
      }

      setIsCapturing(true);

      await new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve);
        });
      });

      const previewImage = await getPreviewImage();

      setIsCapturing(false);

      const data = {
        captcha_token: captcha_token,
        customer_id: 2177,
        user_id: 217286,
        // session_id: session.sid,
        quantity: curBox.quantity,
        adors: {
          Photo: croppedImage,
        },
        output_type: "JOB_INFO",
        confirmation_email: 1,
        image_content: previewImage,
        customs: {
          //message: curBox.layout.message,
          message: {
            ...curBox.layout.message,
            text: messageText
          },
          design_template: curBox.design_template,
          contact_name: curBox.contact_name,
          company_name: curBox.company_name,
          customer_type: curBox.customer_type,
          email: curBox.email,
          phone: curBox.phone,
          street: curBox.street,
          city: curBox.city,
          state: curBox.state,
          zip_code: curBox.zip_code,
          sleeve_type: curBox.sleeve_type,
          wrapping_paper: curBox.wrapping_paper,
          candy_assortment: curBox.candy_assortment,
        },
      };

      // If it's not the custom template and the text box is empty
      if (data.customs.design_template !== 'custom' && messageText === "") {
        const proceed = confirm(
          "Warning: The text box is empty.\n\n" +
          "Click Cancel if you would like to add text to your design.\n" +
          "Click OK to continue without text."
        );

        if (!proceed) {
          return;
        }
      }

      PreorderService.add(data)
        .then((res) => {
          if (res.data.result == 1) {
            console.log('success');
            setOrderConfirmation(true);
            // Call parent to close iframe
            let msg = {
              sid: session.sid,
              action: "close",
              customer_info: data["customs"],
              photo: croppedImage,
            };
            // window.parent.postMessage(msg, "https://volume-savings.sees.com");
            // window.parent.postMessage(msg, "*");
          } else {
            console.error(res.data.data);
          }
          captchaRef.current.reset();
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
    return false;
  };

  const todayDate = () => {
    let dt = new Date();
    return dt.toLocaleDateString();
  };

  const getPreviewImage = async () => {
    return await canvasContent();
  }

  return curBox && (
    <>
      <Container className="py-1 is-screen">
        <Form>
          {orderConfirmation ? (
            <div style={{ height: "100vh" }} className="d-flex flex-column justify-content-center">
              <h2 className="mb-3 text-center">Sweet Success</h2>
              <p className="w-50 text-center mx-auto">
                Your logo sleeve submission has been received. A member of our Candy Concierge team will be in touch within the next 48 business hours to complete your order.
              </p>
              <div className="w-100 text-center">
                <a href="https://volume-savings.sees.com/">
                  <button id="continueShoppingBtn">
                    CONTINUE SHOPPING
                  </button>
                </a>
              </div>
            </div>
          ) : (
            <>
              <div className="customize-box-steps d-flex flex-column flex-md-row justify-content-md-center align-items-start align-items-md-center mt-3 mb-4">
                <div className="cb-step-1 d-flex gap-3 justify-content-center align-items-center">
                  <Link
                    href="#customizeBox"
                    to="customizeBox"
                    smooth={true}
                    offset={-20}
                    duration={400}
                    className="d-flex gap-4 justify-content-center align-items-center step-num"
                  >
                    1
                  </Link>

                  <div className="step-title">
                    <Link
                      href="#customizeBox"
                      to="customizeBox"
                      smooth={true}
                      offset={-20}
                      duration={400}
                      className="text-decoration-none"
                    >
                      Customize
                    </Link>
                  </div>
                </div>

                <div className="cb-step-1 d-flex gap-3 justify-content-center align-items-center">
                  <Link
                    href="#selectCandy"
                    to="selectCandy"
                    smooth={true}
                    offset={-20}
                    duration={750}
                    className={`d-flex gap-4 justify-content-center align-items-center step-num ${custCompleted ? '' : 'inactive'}`}
                  >
                    2
                  </Link>

                  <div className="step-title">
                    <Link
                      href="#selectCandy"
                      to="selectCandy"
                      smooth={true}
                      offset={-20}
                      duration={750}
                      className="text-decoration-none"
                    >
                      Select Candy / Wrap
                    </Link>
                  </div>
                </div>

                <div className="cb-step-1 d-flex gap-3 justify-content-center align-items-center">
                  <Link
                    href="#selectCandySubmit"
                    to="selectCandySubmit"
                    smooth={true}
                    offset={-20}
                    duration={750}
                    className={`d-flex gap-4 justify-content-center align-items-center step-num inactive`}
                  >
                    3
                  </Link>
                  <div className="step-title">
                    <Link
                      href="#selectCandySubmit"
                      to="selectCandySubmit"
                      smooth={true}
                      offset={-20}
                      duration={750}
                      className="text-decoration-none"
                    >
                      Submit
                    </Link>
                  </div>
                </div>
              </div>

              <div id="customizeBox" className="see-form pt-lg-4 mb-2">
                <h2 className="mb-3 text-center">Customize Your Box Sleeve</h2>
                <div className="row">
                  <div className="col">
                    <div id="my-canvas" className="p-3" style={{ justifyItems: "center" }}>
                      <div ref={myCanvas} className="" style={{
                        backgroundImage: `url("/staging-sees/dist/img/backdrops/${curBox.layout.backdrop.backdropImage}")`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        height: curBox.height, // or any desired height
                        width: curBox.width,
                        border: "1px dashed #CCC"
                      }}>
                        <div style={{
                          position: "relative",
                          left: curBox.layout.backdrop.boxLeft,
                          top: curBox.layout.backdrop.boxTop,
                          width: curBox.layout.backdrop.boxWidth,
                          height: curBox.layout.backdrop.boxHeight,
                          // border: "1px solid #EEE",
                          backgroundColor: curBox.layout.backdrop.backgroundColor
                        }}>
                          {!imageToCrop ? (
                            <span
                              id="addImgText"
                              className="position-absolute top-50 start-50 translate-middle z-1"
                              style={{
                                fontFamily: "var(--itc-font)",
                                fontSize: curBox.layout.backdrop.fontSize,
                                // fontWeight: "bold",
                                color: "#757575"
                              }}
                            >
                              Add an image
                            </span>
                          ) : (
                            <img
                              src={imageToCrop}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain"
                              }}
                              alt=""
                            />
                          )}
                        </div>
                        {curBox.design_template !== "custom" && (
                          <div
                            style={{
                              position: "relative",
                              left: curBox.layout.message.boxLeft,
                              top: curBox.layout.message.boxTop,
                              width: curBox.layout.message.boxWidth,
                              height: curBox.layout.message.boxHeight
                            }}
                          >
                            <textarea
                              style={{
                                display: isCapturing ? "none" : "block",
                                width: "100%",
                                height: "100%",
                                boxSizing: "border-box",
                                border: "none",
                                fontFamily: "var(--itc-font)",
                                fontSize: curBox.layout.message.fontSize,
                                // fontWeight: "bold",
                                color: curBox.layout.message.fontColor,
                                textAlign: "center",
                                backgroundColor: curBox.layout.message.backgroundColor,
                                resize: "none",
                                overflow: "hidden",
                                padding: 0,
                                lineHeight: "1.5"
                              }}
                              ref={messageRef}
                              id="message"
                              name="message"
                              rows={3}
                              placeholder="Enter your text"
                              value={curBox.layout.message.text}
                              onChange={handleChange}
                              spellCheck="true"
                              wrap="hard"
                            />

                            <div
                              id="message-capture"
                              style={{
                                display: isCapturing ? "flex" : "none",
                                position: "absolute",
                                inset: 0,
                                width: "100%",
                                height: "100%",
                                boxSizing: "border-box",
                                fontFamily: "var(--itc-font)",
                                fontSize: curBox.layout.message.fontSize,
                                color: curBox.layout.message.fontColor,
                                textAlign: "center",
                                backgroundColor: curBox.layout.message.backgroundColor,
                                lineHeight: "1.5",
                                whiteSpace: "pre-wrap",
                                overflow: "hidden",
                                overflowWrap: "anywhere",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              {curBox.layout.message.text}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <h3 style={{ fontFamily: "var(--itc-font)", fontSize: "20px" }} className="text-center">{boxSizeText}</h3>

                <h2 className="my-3 text-start"
                  style={{ fontSize: "1.2rem" }}
                  id={"selectCandy"}
                >
                  Select Design Template & Upload Photo
                </h2>

                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label
                      className={
                        errors.design_template === true ? "text-danger" : ""
                      }
                      htmlFor="design_template"
                    >
                      Design Template*
                    </label>
                    <br />
                    <span className="text-muted fs-7">
                      * Alternate options available.

                    </span>

                  </Col>
                  <Col md={7}>
                    <Form.Select
                      id="design_template"
                      name="design_template"
                      value={curBox.design_template}
                      onChange={handleChange}
                      className="rounded-0"
                      required
                      aria-errormessage="err_design_template"
                    >
                      <option value=""> </option>
                      <option value="custom">
                        Custom Template (Upload your own design)
                      </option>
                      <option value={whiteSnowflakesTempVal}>
                        White Snowflake Template
                      </option>
                      <option value={redSnowflakesTempVal}>
                        Red Snowflake Template
                      </option>
                      <option value={houseTempVal}>
                        Winter Post Card Template
                      </option>
                      <option value={confettiTempVal}>
                        Confetti Template
                      </option>
                    </Form.Select>
                    {errors.candy_assortment && (
                      <div
                        className="fs-7 text-danger"
                        id="err_candy_assortment"
                      >
                        <i className="fa fa-times-circle m-2"> </i> Candy
                        assortment is required
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="pt-1 pb-1">
                  <Col md={5}>
                    <label htmlFor="image-upload">Upload Photo</label>
                    <br />
                    <span className="text-muted fs-7">
                      <b>(Jpeg or PNG)</b> <br />* We recommend saving artwork
                      in landscape (horizontal) format for best results.
                      {/* <br />* Recommended Specifications */}
                    </span>
                    {/* <br />

                <ul className="text-muted fs-7">
                  <li>Resolution: 300 DPI (dots per inch)</li>
                  <li>Dimensions: At least 1000 pixels on the longest side</li>
                  <li>Color Mode: CMYK (Cyan, Magenta, Yellow, Black) for print</li>
                  <li>File Size: Under 10 MB (larger sizes may be acceptable depending on the printer's capabilities)</li>
                  <li>Quality: High quality, low compression (around 90-100% quality setting)</li>
                  <li style={{ color: "red" }}>Maximum of 50 characters per line</li>
                </ul> */}

                  </Col>
                  <Col md={7}>
                    <Form.Control
                      id="image_upload"
                      className="form-control"
                      type="file"
                      accept="image/*"
                      onChange={onUploadFile}
                      required
                      aria-errormessage="err_image_upload"
                    />
                    {warning && (
                      <div
                        id="warning_image_upload"
                        className="text-danger fs-7 mt-1"
                      >
                        {" "}
                        Warning : Higher resolution image is recommended.

                      </div>
                    )}
                    {errors.image_upload && (
                      <div className="fs-7 text-danger" id="err_image_upload">
                        <i className="fa fa-times-circle m-2"> </i> Image upload
                        is required.
                      </div>
                    )}
                    { /*
                <div>
                  <ImageCropper
                    imageToCrop={imageToCrop}
                    onImageCropped={onCropImage}
                  />
                </div>
                */ }
                  </Col>
                </Row>


                <h2 className="my-3 text-start"
                  style={{ fontSize: "1.2rem" }}
                  id={"selectCandy"}
                >
                  Select Candy & Wrapping Paper
                </h2>

                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label htmlFor="sleeve_type">Sleeve Type</label>
                  </Col>
                  <Col md={7}>
                    <Form.Select
                      name="sleeve_type"
                      value={curBox.sleeve_type}
                      onChange={handleChange}
                    >
                      <option value=""> </option>
                      <option value="standard">Standard</option>
                      <option value="gold">Gold Foil</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label
                      className={
                        errors.candy_assortment === true ? "text-danger" : ""
                      }
                      htmlFor="candy_assortment"
                    >
                      Candy Assortment*
                    </label>

                  </Col>
                  <Col md={7}>
                    <Form.Select
                      id="candy_assortment"
                      name="candy_assortment"
                      value={curBox.candy_assortment}
                      onChange={handleChange}
                      className="rounded-0"
                      required
                      aria-errormessage="err_candy_assortment"
                      disabled={!curBox.sleeve_type}
                    >
                      <option value=""> </option>

                      {candyOptions.map(group => (
                        <optgroup key={group.label} label={group.label}>
                          {group.options.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label} - $
                              {option.prices[curBox.sleeve_type]?.toFixed(2)}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </Form.Select>
                    {errors.candy_assortment && (
                      <div
                        className="fs-7 text-danger"
                        id="err_candy_assortment"
                      >
                        <i className="fa fa-times-circle m-2"> </i> Candy
                        assortment is required
                      </div>
                    )}
                  </Col>
                </Row>

                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label htmlFor="wrapping_paper">Wrapping Paper</label>
                  </Col>
                  <Col md={7}>
                    <Form.Select
                      id="wrapping_paper"
                      name="wrapping_paper"
                      value={curBox.wrapping_paper}
                      onChange={handleChange}
                      className="rounded-0"
                    >
                      <option value=""> </option>
                      <option value="White"> White </option>
                      <option value="Seasonal"> Seasonal </option>
                    </Form.Select>
                  </Col>
                </Row>


                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label htmlFor="quantity">Quantity</label>
                    <br />
                    <span className="text-muted fs-7">
                      (Minimum order of {50}{" "}
                      units applies)
                    </span>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      id="quantity"
                      name="quantity"
                      value={curBox && curBox.quantity}
                      onChange={handleChange}
                      type="number"
                      min={50}
                      max={curBox && curBox.max_quantity}
                      className="form-control"
                      required
                      aria-errormessage="err_quantity"
                    />
                    {errors.quantity && (
                      <div className="fs-7 text-danger" id="err_quantity">
                        <i className="fa fa-times-circle m-2"> </i>
                        Quantity must be greater than {50}
                      </div>
                    )}
                  </Col>
                </Row>
                {/* 
                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label for="message">Message on Logo Box (optional)</label><br />
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={curBox && curBox.message}
                      onChange={handleChange}
                      name="message"
                      id="message"
                      as="textarea"
                      rows={3}
                      className="rounded-0"
                    />
                  </Col>
                </Row>
            */}

                <div className="step-tabs">
                  <h2 className="my-3 text-start" style={{ fontSize: "1.2rem" }}>
                    Enter Customer Information
                  </h2>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label htmlFor="company_name">Company</label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="company_name"
                        name="company_name"
                        value={curBox && curBox.company_name}
                        onChange={handleChange}
                        type="text"
                        placeholder="Company Name"
                        className="rounded-0"
                      />
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={
                          errors.customer_type === true ? "text-danger" : ""
                        }
                        htmlFor="customer_type"
                      >
                        Customer*
                      </label>
                      <br />
                    </Col>
                    <Col md={7}>
                      <Form.Select
                        id="customer_type"
                        name="customer_type"
                        value={curBox && curBox.customer_type}
                        onChange={handleChange}
                        className="rounded-0"
                        required
                        aria-errormessage="err_customer_type"
                      >
                        <option value=""> </option>
                        <option value="New"> New </option>
                        <option value="Returning"> Returning </option>
                      </Form.Select>
                      {errors.customer_type && (
                        <div
                          className="fs-7 text-danger"
                          id="err_customer_type"
                        >
                          <i className="fa fa-times-circle m-2"> </i>
                          Customer is required
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={
                          errors.contact_name === true ? "text-danger" : ""
                        }
                        htmlFor="contact_name"
                      >
                        Contact Name*
                      </label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="contact_name"
                        name="contact_name"
                        value={curBox && curBox.contact_name}
                        onChange={handleChange}
                        type="text"
                        placeholder="Full Name"
                        className="rounded-0"
                        required
                        aria-errormessage="err_contact_name"
                      />
                      {errors.contact_name && (
                        <div className="fs-7 text-danger" id="err_contact_name">
                          <i className="fa fa-times-circle m-2"> </i>
                          Contact name is required
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={errors.email === true ? "text-danger" : ""}
                        htmlFor="email"
                      >
                        Email*
                      </label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="email"
                        name="email"
                        value={curBox && curBox.email}
                        onChange={handleChange}
                        type="email"
                        pattern=".+@.+\..+"
                        placeholder="Email"
                        className="rounded-0"
                        required
                        aria-errormessage="err_email"
                      />
                      {errors.email && (
                        <div className="fs-7 text-danger" id="err_email">
                          <i className="fa fa-times-circle m-2"> </i> Email is
                          invalid
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={errors.phone === true ? "text-danger" : ""}
                        htmlFor="phone"
                      >
                        Phone*
                      </label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="phone"
                        name="phone"
                        value={curBox && curBox.phone}
                        onChange={handleChange}
                        type="tel"
                        placeholder="Phone"
                        className="rounded-0"
                        required
                        aria-errormessage="err_phone"
                      />
                      {errors.phone && (
                        <div className="fs-7 text-danger" id="err_phone">
                          <i className="fa fa-times-circle m-2"> </i> Phone number is required
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={errors.street === true ? "text-danger" : ""}
                        htmlFor="street"
                      >
                        Shipping address*
                      </label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="street"
                        name="street"
                        value={curBox && curBox.street}
                        onChange={handleChange}
                        type="text"
                        placeholder="Street address"
                        className="rounded-0"
                        required
                        aria-errormessage="err_street"
                      />
                      {errors.street && (
                        <div className="fs-7 text-danger" id="err_street">
                          <i className="fa fa-times-circle m-2"> </i> Street
                          address is required
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={errors.city === true ? "text-danger" : ""}
                        htmlFor="city"
                      >
                        City*
                      </label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="city"
                        name="city"
                        value={curBox && curBox.city}
                        onChange={handleChange}
                        type="text"
                        placeholder="City"
                        className="rounded-0"
                        required
                        aria-errormessage="err_city"
                      />
                      {errors.city && (
                        <div className="fs-7 text-danger" id="err_city">
                          <i className="fa fa-times-circle m-2"> </i> City is required </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={errors.state === true ? "text-danger" : ""}
                        htmlFor="state"
                      >
                        State*
                      </label>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="state"
                        name="state"
                        value={curBox && curBox.state}
                        onChange={handleChange}
                        type="text"
                        placeholder="State"
                        className="rounded-0"
                        required
                        aria-errormessage="err_state"
                      />
                      {errors.state && (
                        <div className="fs-7 text-danger" id="err_state">
                          <i className="fa fa-times-circle m-2"> </i> State is
                          required
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-3">
                    <Col md={5}>
                      <label
                        className={
                          errors.zip_code === true ? "text-danger" : ""
                        }
                        htmlFor="zip_code"
                      >
                        Postal code*
                      </label>


                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id="zip_code"
                        name="zip_code"
                        value={curBox && curBox.zip_code}
                        onChange={handleChange}
                        type="text"
                        placeholder="Postal code"
                        className="rounded-0"
                        required
                        aria-errormessage="err_zip_code"
                      />

                      {errors.zip_code && (
                        <div className="fs-7 text-danger" id="err_zip_code">
                          <i className="fa fa-times-circle m-2"> </i> Postal
                          code is required
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-3">
                    <Col md={5}>
                      <p className="my-1"> </p>
                    </Col>
                    <Col md={7}>

                      <CAPTCHA
                        ref={captchaRef}
                        sitekey={process.env.REACT_APP_SITE_KEY}
                      />
                      <div
                        id="selectCandySubmit"
                        className="text-center mt-4 d-flex gap-4 justify-content-center align-items-center"
                      >
                        <span className="fs-6" id="">Please allow a 4-5 week lead time.</span>
                        <button
                          className="btn bg-black text-white rounded-0 ms-auto"
                          id="submit_btn"
                          name="submit_btn"
                          type="submit"
                          onClick={handleSubmit}
                        >
                          Submit Inquiry
                        </button>
                      </div>

                    </Col>
                  </Row>
                </div>
              </div>
            </>
          )}

        </Form>
      </Container >


    </>
  );
};

export default BoxSleeve;
